<div class="br-modal-header">
  <h1 class="modal-title">Confirmar Cadastro Reserva</h1>
</div>
<div class="br-modal-body">
  <div class="p-4 termo-content">
    <p class="termo-text">
      <span class="termo-text-heading">TERMO DE ADESÃO AO CADASTRO RESERVA E COMPROMISSO QUE ENTRE SI CELEBRAM O
      MINISTÉRIO DA SAÚDE E O MUNICÍPIO / DISTRITO
      {{ municipio.nome + "/" + municipio.siglaUf }} PARA ADESÃO AO PROJETO MAIS
      MÉDICOS PARA O BRASIL - PMMB.</span><br />
      O MINISTÉRIO DA SAÚDE, CNPJ nº 03.274.533/0001-50, neste ato representado
      por FELIPE PROENÇO DE OLIVEIRA, Secretário de Gestão do Trabalho e
      Educação na Saúde, com endereço na Esplanada dos Ministérios, Bloco "O",
      7º andar, sala 716, CEP 70.058-900, Brasília/DF, e o MUNICÍPIO de
      {{ municipio.nome + "/" + municipio.siglaUf }}, (endereço, CNPJ), neste
      ato representado por {{ usuario.nome }}, (qualificação), nos termos da Lei
      nº 12.871, de 22 de outubro de 2013, alterada pela Lei nº 14.621, de 14 de
      julho de 2023, da Portaria Interministerial MS/MEC nº 604, de 16 de maio
      de 2023, e das demais normas que compõem o arcabouço normativo do Projeto
      Mais Médicos para o Brasil - PMMB resolvem celebrar o presente Termo de
      Adesão ou Renovação da Adesão e Compromisso ao PMMB, mediante as cláusulas
      e condições seguintes: <br /><br />
      CLÁUSULA PRIMEIRA - DO OBJETO<br />
      O presente termo tem por objeto a Adesão ou Renovação da Adesão e
      Compromisso do Município que diante da data de corte estabelecida nos
      termos do EDITAL Nº 22 DE 2 DE FEVEREIRO DE 2026 (45° CICLO) apresenta-se
      com todas as vagas ativas ocupadas, poderá abrir na condição de cadastro
      reserva, para preenchimento das vagas desocupadas oriundas de desligamento
      e/ou movimentação de profissionais, ao longo do ano de 2025, no Programa
      de Provimento de Médicos do Ministério da Saúde - Projeto Mais Médicos
      para o Brasil, nos termos do EDITAL Nº 22 DE 2 DE FEVEREIRO DE 2026 (45°
      CICLO) bem como definir obrigações e responsabilidades mútuas com a
      finalidade de realizar o aperfeiçoamento de médicos participantes em
      regiões prioritárias para o SUS, mediante integração ensino-serviço que
      envolve componente assistencial a ser desenvolvido na atenção primária do
      município aderido bem como a oferta de cursos de especialização e
      aperfeiçoamento por instituição pública de educação superior considerando
      atividades de ensino, pesquisa e extensão.
      <br /><br />
      CLÁUSULA SEGUNDA - DOS COMPROMISSOS COM A POLÍTICA NACIONAL DE ATENÇÃO
      PRIMÁRIA<br />
      O Município executará suas ações no Programa, orientado pelas premissas
      dispostas na Política Nacional de Atenção Básica, definida nos termos da
      Portaria nº 2.436, de 21 de setembro de 2017, atendendo ainda às
      responsabilidades previstas na Lei nº 12.871, de 22 de outubro de 2013,
      alterada pela Lei nº 14.621, de 14 de julho de 2023, e na Portaria
      Interministerial MS/MEC nº 604, de 16 de maio de 2023, além do
      estabelecido no presente Termo.
      <br /><br />
      CLÁUSULA TERCEIRA - DAS OBRIGAÇÕES DOS MUNICÍPIOS/DISTRITO FEDERAL NO
      PROJETO MAIS MÉDICOS PARA O BRASIL - PMMB<br />
      Para consecução do objeto estabelecido neste Termo de Renovação e/ou
      Adesão e Compromisso, o município deverá atender aos seguintes aspectos
      relativos aos médicos participantes do PMMB, além de outros que podem ser
      estabelecidos pela Coordenação Nacional:<br />
      a) receber, acolher e recepcionar os médicos participantes e adotar as
      providências necessárias para a acomodação dos mesmos quanto às atividades
      na Unidade Básica de Saúde estabelecida;<br />
      b) inserir o médico participante do PMMB, no prazo máximo de 60 (sessenta)
      dias, em equipes de atenção básica, nas modalidades previstas na Política
      Nacional de Atenção Básica e em regiões prioritárias para o SUS,
      respeitando os critérios de distribuição estabelecidos no Projeto, e
      mantê-los durante a vigência do Termo de Renovação e/ou de Adesão e
      Compromisso;<br />
      c) priorizar a alocação dos médicos participantes do Programa nas equipes
      de atenção básica que não estejam constituídas com médicos e/ou que
      atendam populações que dependam exclusivamente da atenção do SUS e/ou
      atendam populações vulneráveis e historicamente excluídas, tais como,
      ribeirinhas, quilombolas, assentados, extrativistas, em situação de rua,
      prisional e indígenas aldeados;<br />
      d) constituir novas equipes de atenção básica após a prévia inserção de
      médicos participantes do PMMB nas equipes em funcionamento sem médicos,
      conforme alínea “c” do presente Termo de Renovação e/ou de Adesão e
      Compromisso;<br />
      e) quando da apresentação do médico no município para o início das
      atividades, informar no Sistema de Gerenciamento de Programas (SGP) o
      número do CNES da Unidade de Saúde e INE (se já houver) da equipe em que o
      médico irá atuar;<br />
      f) cadastrar o médico participante no Cadastro Nacional de
      Estabelecimentos de Saúde (CNES) e identificá-lo na respectiva equipe de
      atenção básica em que atuará, de acordo com orientações expedidas pelo
      Ministério da Saúde, no prazo máximo de 30 dias, prorrogáveis por mais 30
      dias, a partir da apresentação do médico no Município;<br />
      g) prover condições ao médico para que realize o preenchimento do Sistema
      de Informação da Atenção Básica - SISAB nos termos das Portarias
      regulamentares do sistema;<br />
      h) manter os dados do gestor e coordenador responsável atualizado, e, em
      caso de mudança do gestor, solicitar, de imediato, novo cadastramento no
      SGP;<br />
      i) acompanhar e fiscalizar o cumprimento da carga horária de 44 (quarenta
      e quatro) horas semanais do(s) médico(s) bolsista(s), considerando 36
      (trinta e seis) horas dedicadas ao desenvolvimento de atividades
      assistenciais no atendimento ao usuário do SUS, realizado em
      estabelecimento de saúde que oferte ações e serviços de Atenção Primária à
      Saúde no âmbito do município/distrito, preferencialmente distribuídas em 5
      (cinco) dias da semana e 8 (oito) horas dedicadas às atividades
      pedagógicas, considerando cursos de aperfeiçoamento ou de pós- graduação
      lato ou stricto sensu, ofertados por instituições de ensino e pesquisa
      sendo, no mínimo, 50% (cinquenta por cento) dessa carga horária ofertada
      de forma síncrona;<br />
      j) fornecer condições adequadas para a atuação do médico participante,
      inclusive acessibilidade para médicos participantes com deficiência ou
      mobilidade reduzida, coibindo qualquer forma de discriminação por motivo
      de deficiência, e conforme exigências e especificações da Política
      Nacional de Atenção Básica, tais como estrutura da unidade de saúde
      adequada, com segurança e higiene, fornecimento de equipamentos e insumos
      necessários e instalações sanitárias para o desempenho das atividades;<br />
      k) ser corresponsável com o Ministério da Saúde pelo cumprimento do
      decreto nº 11.785, de 20 de novembro de 2023 no que diz respeito à
      promoção, no âmbito municipal, de instrumentos e medidas que garantam
      ações de combate ao racismo, discriminação e a promoção da igualdade por
      meio de ações afirmativas voltado para os participantes cotistas inseridos
      em equipe dentro do município;<br />
      k) oferecer transporte adequado e seguro para o médico participante do
      PMMB deslocar-se para o local de desenvolvimento das atividades nas
      unidades básicas de saúde, apenas em caso de locais de difícil acesso;<br />
      l) atuar em cooperação com os entes federativos, instituições de educação
      superior e a supervisão, no âmbito de sua competência, para as ações de
      execução do PMMB;<br />
      m) atuar em parceria com a instituição de educação superior responsável
      pelo curso de especialização dos médicos participantes do Programa,
      inclusive na definição e execução das atividades de ensino, pesquisa e
      extensão a serem desenvolvidas no âmbito do PMMB;<br />
      n) exercer, em conjunto com o supervisor, a forma de cumprimento da carga
      horária, o acompanhamento e a fiscalização da execução das atividades de
      ensino-serviço, inclusive quanto ao cumprimento da carga horária semanal
      prevista pelo Projeto para os médicos participantes das atividades
      assistenciais e atividades teóricas para o PMMB, ressalvadas as
      especificidades das equipes de saúde da família ribeirinhas, fluviais, de
      saúde indígena, de atenção primária prisional, de consultório na rua e de
      consultório na rua;<br />
      o) comunicar imediatamente à Coordenação do Programa os afastamentos,
      períodos de descanso, ausências justificadas ou injustificadas,
      solicitação de desligamento do participante, irregularidade ou denúncia
      que tenha ciência em razão de atos de terceiros ou de ofício para que
      sejam adotadas as providências pertinentes e necessárias ao bom andamento
      e execução do PMMB;<br />
      p) adequar as ações de aperfeiçoamento, quando as condições de saúde assim
      exigirem, retomando-se as atividades anteriormente exercidas após melhora
      da situação de saúde, inclusive para a condição de médica gestante;<br />
      q) garantir para médica gestante a dispensa das ações de aperfeiçoamento
      para realizar, no mínimo, 7 (sete) consultas médicas e demais exames
      complementares no pré-natal;<br />
      r) adotar as providências necessárias para garantir a atenção à saúde ao
      médico participante, por meio do Sistema Único de Saúde e/ou outros
      mecanismos públicos de Assistência Social;<br />
      s) articular com os órgãos responsáveis pela Segurança Pública, na esfera
      municipal, a fim de garantir a integridade física dos médicos
      participantes;<br />
      t) garantir acesso virtual ou telefônico ao Telessaúde Brasil Redes,
      conforme disponibilidade de rede do Município;<br />
      u) não substituir médicos que já componham as equipes de atenção básica
      pelo médico participante do Projeto; e,<br />
      v) responder as pesquisas de satisfação sobre o PMMB.<br />
      Parágrafo único: Constituem-se responsabilidades / obrigações do Município
      no Projeto Mais Médicos para o Brasil (contrapartidas municipais):<br />
      I - Garantir moradia, no próprio município, para o médico participante do
      Projeto Mais Médicos para o Brasil, a qual deve ter condições de
      habitabilidade e atender ao padrão médio de moradia da localidade, podendo
      ser em forma pecuniária ou oferta de acomodação pelo Município.
      <br /><br />
      CLÁUSULA QUARTA - DAS OBRIGAÇÕES DO MINISTÉRIO DA SAÚDE<br />
      Constituem-se obrigações do Ministério da Saúde:<br />
      a) selecionar e encaminhar, segundo os critérios estabelecidos no PMMB,
      médicos para o os Municípios que celebram o presente Termo de Adesão ou
      Renovação da Adesão e Compromisso;<br />
      b) garantir o pagamento da bolsa-formação ao médico participante do
      Programa durante todo o período de participação nas ações de
      aperfeiçoamento, conforme as regras de validação das atividades;<br />
      c) atendidos critérios legais pelo médico participante do PMMB, efetuar o
      pagamento de ajuda de custo destinada a compensar as suas despesas de
      instalação nos termos do art.24 da Portaria Interministerial MS/MEC nº 604
      de 16 de maio de 2023;<br />
      d) garantir, em conjunto com o Ministério da Educação, a realização dos
      cursos de especialização e demais ofertas pedagógicas aos médicos
      participantes do Programa, a serem oferecidos em parceria com instituições
      de educação superior brasileiras vinculadas ao Sistema Universidade Aberta
      do Sistema Único de Saúde (UNA-SUS); e<br />
      e) ofertar aos médicos participantes do PMMB a inscrição em serviços de
      Telessaúde.
      <br /><br />
      CLÁUSULA QUINTA - DAS SANÇÕES<br />
      O Município ou Distrito Federal que deixar de cumprir suas atribuições,
      estabelecidas conforme as regras do PMMB e do presente Termo de Adesão ou
      Renovação da Adesão e Compromisso poderá ser descredenciado do Projeto
      Mais Médicos para o Brasil ou ter suas vagas suspensas, observados os
      seguintes termos:<br />
      a) O Município e o Distrito Federal serão notificados das irregularidades
      apuradas, sendo-lhe concedido o prazo de 05 (cinco) dias úteis para
      apresentar manifestação e justificativas, para análise pela Coordenação do
      Projeto;<br />
      b) Decorrido o prazo estabelecido na alínea anterior, com ou sem
      manifestação por parte do Município e Distrito Federal, a Coordenação do
      Projeto Mais Médicos para o Brasil decidirá quanto ao descredenciamento ou
      indicará a necessidade de adoção, no prazo máximo de 15 (quinze) dias,
      prorrogável por igual período, de providências pelo Município e/ou
      Distrito Federal;<br />
      c) A Coordenação do Projeto Mais Médicos para o Brasil poderá estabelecer,
      inclusive previamente ao prazo de manifestação, penalidades de bloqueio de
      vagas e remanejamento de médicos, devidamente justificada;<br />
      d) Não sendo adotadas pelo Município ou Distrito Federal as providências
      determinadas pela Coordenação do Programa no prazo fixado na alínea
      anterior, o Município e o Distrito Federal poderão ser excluídos do PMMB
      ou serão descredenciadas as vagas objeto de questionamento;<br />
      e) Na hipótese de que trata a alínea anterior, o médico participante do
      Projeto poderá ser remanejado para outro ente federativo, a ser definido
      pela Coordenação, de acordo com as necessidades do Projeto; e<br />
      f) As impropriedades apuradas não eximem a Coordenação do Projeto de
      adotar outras providências que entender cabíveis, especialmente enviar
      comunicações e dar conhecimento dos fatos aos órgãos e entidades públicas
      competentes.<br />
      Parágrafo único: As notificações de trata essa cláusula serão efetivadas
      por correspondência eletrônica, dirigida ao endereço eletrônico cadastrado
      pelo gestor no Sistema de Gerenciamento de Programas (SGP) quando do
      preenchimento do formulário de adesão e por via postal ao endereço do
      Município e Distrito Federal indicado no sistema, sendo válida para efeito
      de cômputo de prazo a que primeiro tenha sido recebida.
      <br /><br />
      CLÁUSULA SEXTA - DA VIGÊNCIA<br />
      O presente Termo de Renovação da Adesão e Compromisso terá vigência de 48
      (quarenta e oito) meses, a partir da data da sua confirmação, podendo ser
      prorrogado mediante celebração de termo aditivo.
      <br /><br />
      CLÁUSULA SÉTIMA - DA RESCISÃO<br />
      O presente Termo de Renovação e/ou Adesão e Compromisso poderá ser
      rescindido, durante o prazo de vigência, por mútuo consentimento ou
      unilateralmente por qualquer um dos partícipes, mediante manifestação
      encaminhada com antecedência mínima de 30 (trinta) dias.
      <br /><br />
      CLÁUSULA OITAVA - DAS ALTERAÇÕES<br />
      As eventuais alterações do presente Termo de Renovação e/ou Adesão e
      Compromisso serão realizadas por meio de termo aditivo acordado entre os
      partícipes.
      <br /><br />
      CLÁUSULA NONA - DA SOLUÇÃO DE CONTROVÉRSIAS E DOS CASOS OMISSOS<br />
      Eventual controvérsia surgida durante a execução do presente Termo de
      Renovação e/ou da Adesão e Compromisso poderá ser dirimida
      administrativamente entre os partícipes, bem como as situações
      eventualmente não previstas que serão solucionadas de comum acordo entre
      os partícipes, cujo direcionamento deve visar à execução integral do
      objeto.
      <br /><br />
      Local,
      {{
        getDataConfirmacaoFormatada(cadastrosReservaMunicipio[0].dtConfirmacao)
      }}.
    </p>
  </div>

  <form [formGroup]="form" novalidate>
    <div class="mb-4 mt-4">
      <div class="br-checkbox">
        <input
          id="termoAdesao"
          name="termoAdesao"
          type="checkbox"
          aria-label="opção 1"
          formControlName="termoAdesao"
          [value]="true"
        />
        <label for="termoAdesao"
          >Li e concordo com termo de Adesão ao Cadastro de Reserva.</label
        >
      </div>
    </div>
    <div formArrayName="cadastrosReservaMunicipio">
      <div
        *ngFor="
          let cadastroReservaMunicipio of cadastrosFormArray.controls;
          let i = index
        "
        [formGroupName]="i"
      >
        <div class="mt-4">
          <label for=""
            >Confirmar Cadastro Reserva para o Tipo de Equipe
            {{ cadastroReservaMunicipio.get("tipoEquipe")?.value.nome }}</label
          >
          <div class="d-flex justify-content-start">
            <div class="br-radio">
              <input
                id="'confirmacao_' + {{ i }} + '_sim'"
                type="radio"
                name="confirmacao"
                [value]="true"
                formControlName="confirmacao"
              />
              <label for="'confirmacao_' + {{ i }} + '_sim'" class="me-4"
                >Sim</label
              >

              <input
                id="'confirmacao_' + {{ i }} + '_nao'"
                type="radio"
                name="confirmacao"
                [value]="false"
                formControlName="confirmacao"
              />
              <label for="'confirmacao_' + {{ i }} + '_nao'">Não</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="br-modal-footer justify-content-end">
  @if (isPeriodoVigente && !isConfirmado) {
    <br-button
      [emphasis]="'primary'"
      [disabled]="this.form.invalid || submitting"
      (click)="confirmar()"
      class="ms-2"
      [isLoading]="submitting"
      >Confirmar</br-button
    >
  }
</div>
